export enum LinkType {
  TWO_WAY = 'two_way',
  SHARE = 'share',
}
